// Macalester College's majors (#2748). Read on 2026-10-01 from the
// college's official Areas of Study page (macalester.edu/academics/), which
// lists every department and program and marks whether each offers a
// major, a minor or a concentration: every area marked as a major is kept;
// minors and concentration-only areas (Biochemistry, African Studies and
// others) are left out. Names are the page's own; an area such as "Art and
// Art History" is one entry because the page lists it as one. The official
// online catalog (catalog.macalester.edu) answered curl with an empty 202
// challenge and WebFetch with a certificate error, so it was not used.
// Macalester has no separate schools, so the majors form one group; the
// page names no degree types, so `degree` is null. The KB's majors list was
// the starting point; the college's page wins.
const majors = {
    "slug": "macalester-college",
    "read": "2026-10-01",
    "intro": "Every area of study Macalester lists as offering a major, from the college's official Areas of Study page. Minors and concentrations are left out.",
    "groups": [
        {
            "name": "Macalester College",
            "source": {
                "label": "Macalester College, Areas of Study (filtered to majors)",
                "url": "https://www.macalester.edu/academics/"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art and Art History",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Classical Mediterranean and Middle East",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Educational Studies",
                    "degree": null
                },
                {
                    "name": "English and Creative Writing",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null
                },
                {
                    "name": "Latin American Studies",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Media and Cultural Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Russian Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Theater and Dance",
                    "degree": null
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
